export default "__VITE_ASSET__DrL5W5lS__"